export const GLOBAL_COLORS = "GLOBAL_COLORS";
export const ADD_BG = "ADD_BG";
export const ADD_BG_SURROUND = "ADD_BG_SURROUND";
export const PRESET = "PRESET";
export const ADD_FONT = "ADD_FONT";
export const CONTAINER_WIDTH = "CONTAINER_WIDTH";
export const PIXEL = "PIXEL";
export const PERCENTAGE = "PERCENTAGE";
export const BG_IMAGE = "BG_IMAGE";
export const BG_IMAGE_CONTAINER = "BG_IMAGE_CONTAINER";
export const BG_REPEAT = "BG_REPEAT";
export const BG_SIZE = "BG_SIZE";
export const BG_REPEAT_CONTAINER = "BG_REPEAT_CONTAINER";
export const BG_SIZE_CONTAINER = "BG_SIZE_CONTAINER";
export const BG_IMAGE_ID = "BG_IMAGE_ID";
export const BG_VIDEO = "BG_VIDEO";
export const BG_TYPE = "BG_TYPE";
export const BG_VIDEO_ID = "BG_VIDEO_ID";
export const BG_IMAGES = "BG_IMAGES";
export const BG_IMAGE_INDEX = "BG_IMAGE_INDEX";
export const LAYOUT = "LAYOUT";
export const CANVAS = "CANVAS";
export const INFO = "INFO";
export const RESET = "RESET";
export const TITLE = "TITLE";
export const DESCRIPTION = "DESCRIPTION";
export const TEXT_INDEX = "TEXT_INDEX";
export const RELOAD_API = "RELOAD_API";
export const SET_LAYOUT_LIST = "SET_LAYOUT_LIST"
export const SET_LAYOUT_TITLE = "SET_LAYOUT_TITLE";
export const REORDER_LAYOUT_LIST = "REORDER_LAYOUT_LIST";
export const RENAME_LAYOUT_LIST = "RENAME_LAYOUT_LIST";
export const DELETE_LAYOUT_LIST = "DELETE_LAYOUT_LIST";

export const SET_LAYOUT_LANGUAGES = "SET_LAYOUT_LANGUAGES";

export const SET_ANCHOR_NAVIGATION = "SET_ANCHOR_NAVIGATION";
export const ENABLE_ANCHOR_NAVIGATION = "ENABLE_ANCHOR_NAVIGATION";
export const SET_STICKY_ANCHOR_NAVIGATION = "SET_STICKY_ANCHOR_NAVIGATION";
export const SET_DEFAULT_PAGE = "SET_DEFAULT_PAGE";
export const SET_ANCHOR_LIST = "SET_ANCHOR_LIST";
export const ADD_ANCHOR = "ADD_ANCHOR";
export const RENAME_ANCHOR = "RENAME_ANCHOR";
export const DELETE_ANCHOR = "DELETE_ANCHOR";

export const NAV_CLASS = "NAV_CLASS";
export const INFO_TITLE = "INFO_TITLE";
export const INFO_DESC = "INFO_DESC";
export const INFO_META_TITLE = "INFO_META_TITLE";
export const FLIMP_TMP_ID = "FLIMP_TMP_ID";
export const NAVIGATION_STYLE = "NAVIGATION_STYLE";
export const NAVIGATION_SEARCH = "NAVIGATION_SEARCH";
export const NAVIGATION_ALIGN = "NAVIGATION_ALIGN";
export const CANVAS_PADDING_UNIT = "CANVAS_PADDING_UNIT";
export const CANVAS_PADDING = "CANVAS_PADDING";
export const CANVAS_MARGIN_UNIT = "CANVAS_MARGIN_UNIT";
export const CANVAS_MARGIN = "CANVAS_MARGIN";
export const CANVAS_PADDING_MOBILE = "CANVAS_PADDING_MOBILE";
export const CANVAS_MARGIN_MOBILE = "CANVAS_MARGIN_MOBILE";
export const OVERRIDE_CANVAS_FONT = "OVERRIDE_CANVAS_FONT";
export const OVERRIDE_ELEMENT_FONTS = "OVERRIDE_ELEMENT_FONTS";
export const CANVAS_COLUMN_GAP = "CANVAS_COLUMN_GAP";
export const CANVAS_ROW_GAP = "CANVAS_ROW_GAP";
export const CANVAS_ROWS_PADDING_UNIT = "CANVAS_ROWS_PADDING_UNIT";
export const CANVAS_ROWS_PADDING = "CANVAS_ROWS_PADDING";
export const CANVAS_ROWS_PADDING_MOBILE = "CANVAS_ROWS_PADDING_MOBILE";
export const REPLACE_MICROSITE = "REPLACE_MICROSITE";
export const EMPTY_PRESET = "EMPTY_PRESET";
export const HAMBURGER_COLOR = "HAMBURGER_COLOR";
export const HAMBURGER_MENU = "HAMBURGER_MENU";
export const HAMBURGER_MENU_LABEL = "HAMBURGER_MENU_LABEL";
export const RESET_PAST = 'RESET_PAST'
export const ENABLE_WIDTH_FOR_ROW = "ENABLE_WIDTH_FOR_ROW";
export const SET_CHATBOT_CONTENT = "SET_CHATBOT_CONTENT";
export const GET_CHATBOT_CONTENT = "GET_CHATBOT_CONTENT";
export const SET_CHATBOT_URL = "SET_CHATBOT_URL";
export const GET_CHATBOT_URL = "GET_CHATBOT_URL";
export const SET_CHATBOT_DISPLAY = "SET_CHATBOT_DISPLAY";
export const GET_CHATBOT_DISPLAY = "GET_CHATBOT_DISPLAY";
export const SET_CHATBOT_BUTTON_COLOR = "SET_CHATBOT_BUTTON_COLOR";
export const GET_CHATBOT_BUTTON_COLOR = "GET_CHATBOT_BUTTON_COLOR";
export const SET_CHATBOT_BUTTON_TEXT_COLOR = "SET_CHATBOT_BUTTON_TEXT_COLOR";
export const GET_CHATBOT_BUTTON_TEXT_COLOR = "GET_CHATBOT_BUTTON_TEXT_COLOR";
export const SET_CHATBOT_BUTTON_TEXT = "SET_CHATBOT_BUTTON_TEXT";
export const GET_CHATBOT_BUTTON_TEXT = "GET_CHATBOT_BUTTON_TEXT";


export const set_chatbot_content = (content) => {
  return {
    type: SET_CHATBOT_CONTENT,
    result: content,
  };
};

export const get_chatbot_content = () => {
  return {
    type: GET_CHATBOT_CONTENT,
  };
};

export const get_chatbot_url = () => {
  return {
    type: GET_CHATBOT_URL,
  };
};

export const get_chatbot_display = () => {
  return {
    type: GET_CHATBOT_DISPLAY,
  };
};

export const set_chatbot_url = (url) => {
  return {
    type: SET_CHATBOT_URL,
    result: url,
  };
};

export const set_chatbot_display = (display) => {
  return {
    type: SET_CHATBOT_DISPLAY,
    result: display,
  };
};

export const set_chatbot_button_color = (color) => {
  return {
    type: SET_CHATBOT_BUTTON_COLOR,
    result: color,
  };
};

export const get_chatbot_button_color = () => {
  return {
    type: GET_CHATBOT_BUTTON_COLOR,
  };
};

export const set_chatbot_button_text_color = (color) => {
  return {
    type: SET_CHATBOT_BUTTON_TEXT_COLOR,
    result: color,
  };
};

export const get_chatbot_button_text_color = () => {
  return {
    type: GET_CHATBOT_BUTTON_TEXT_COLOR,
  };
};

export const set_chatbot_button_text = (text) => {
  return {
    type: SET_CHATBOT_BUTTON_TEXT,
    result: text,
  };
};

export const get_chatbot_button_text = () => {
  return {
    type: GET_CHATBOT_BUTTON_TEXT,
  };
};

export const override_canvas_font = (res) => {
  return {
    type: OVERRIDE_CANVAS_FONT,
    result: res,
  };
};
export const enable_width_for_row = (res) => {
  
  return {
    type: ENABLE_WIDTH_FOR_ROW,
    result:res,
  };
};
export const hamburger_color = (res) => {
  return {
    type: HAMBURGER_COLOR,
    result: res,
  };
};
export const hamburger_menu = (res) => {
  return {
    type: HAMBURGER_MENU,
    result: res,
  };
};
export const hamburger_menu_label = (res) => {
  return {
    type: HAMBURGER_MENU_LABEL,
    result: res,
  };
};
export const replace_microsite = (res) => {
  return {
    type: REPLACE_MICROSITE,
    result: res,
  };
};
export const empty_preset = (res) => {
  return {
    type: EMPTY_PRESET,
    result: res,
  };
};
export const global_colors = (res) => {
  return {
    type: GLOBAL_COLORS,
    result: res,
  };
};
export const flimp_tmp_id = (res) => {
  return {
    type: FLIMP_TMP_ID,
    result: res,
  };
};
export const navigation_style = (res) => {
  return {
    type: NAVIGATION_STYLE,
    result: res,
  };
};
export const navigation_search = (res) => {
  return {
    type: NAVIGATION_SEARCH,
    result: res,
  };
};
export const navigation_align = (res) => {
  return {
    type: NAVIGATION_ALIGN,
    result: res,
  };
};
export const nav_class = (res) => {
  return {
    type: NAV_CLASS,
    result: res,
  };
};
export const add_bg = (res) => {
  return {
    type: ADD_BG,
    result: res,
  };
};
export const add_bg_surround = (res) => {
  return {
    type: ADD_BG_SURROUND,
    result: res,
  };
};
export const canvas_margin_unit = (res) => {
  return {
    type: CANVAS_MARGIN_UNIT,
    result: res,
  };
};
export const canvas_margin = (res) => {
  return {
    type: CANVAS_MARGIN,
    result: res,
  };
};
export const canvas_padding_unit = (res) => {
  return {
    type: CANVAS_PADDING_UNIT,
    result: res,
  };
};
export const canvas_padding = (res) => {
  return {
    type: CANVAS_PADDING,
    result: res,
  };
};
export const canvas_margin_mobile = (res) => {
  return {
    type: CANVAS_MARGIN_MOBILE,
    result: res,
  };
};
export const canvas_padding_mobile = (res) => {
  return {
    type: CANVAS_PADDING_MOBILE,
    result: res,
  };
};
export const canvas_rows_padding_unit = (res) => {
  return {
    type: CANVAS_ROWS_PADDING_UNIT,
    result: res,
  };
};
export const canvas_rows_padding = (res) => {
  return {
    type: CANVAS_ROWS_PADDING,
    result: res,
  };
};
export const canvas_rows_padding_mobile = (res) => {
  return {
    type: CANVAS_ROWS_PADDING_MOBILE,
    result: res,
  };
};
export const preset = (res) => {
  return {
    type: PRESET,
    result: res,
  };
};

export const add_font = (res) => {
  return {
    type: ADD_FONT,
    result: res,
  };
};

export const container_width = (res) => {
  return {
    type: CONTAINER_WIDTH,
    result: res,
  };
};

export const pixel = (res) => {
  return {
    type: PIXEL,
    result: res,
  };
};

export const percentage = (res) => {
  return {
    type: PERCENTAGE,
    result: res,
  };
};

export const bg_image = (res) => {
  return {
    type: BG_IMAGE,
    result: res,
  };
};
export const bg_image_container = (res) => {
  return {
    type: BG_IMAGE_CONTAINER,
    result: res,
  };
};
export const bg_repeat_container = (res) => {
  return {
    type: BG_REPEAT_CONTAINER,
    result: res,
  };
};
export const bg_size_container = (res) => {
  return {
    type: BG_SIZE_CONTAINER,
    result: res,
  };
};
export const bg_repeat = (res) => {
  return {
    type: BG_REPEAT,
    result: res,
  };
};
export const bg_size = (res) => {
  return {
    type: BG_SIZE,
    result: res,
  };
};
export const bg_image_id = (res) => {
  return {
    type: BG_IMAGE_ID,
    result: res,
  };
};
export const bg_video = (res) => {
  return {
    type: BG_VIDEO,
    result: res,
  };
};
export const bg_video_id = (res) => {
  return {
    type: BG_VIDEO_ID,
    result: res,
  };
};
export const bg_type = (res) => {
  return {
    type: BG_TYPE,
    result: res,
  };
};
export const bg_images = (res) => {
  return {
    type: BG_IMAGES,
    result: res,
  };
};
export const bg_image_index = (res) => {
  return {
    type: BG_IMAGE_INDEX,
    result: res,
  };
};

export const canvas = (res) => {
  return {
    type: CANVAS,
    result: res,
  };
};

export const infoTitle = (res) => {
  return {
    type: INFO_TITLE,
    result: res,
  };
};
export const infoDesc = (res) => {
  return {
    type: INFO_DESC,
    result: res,
  };
};
export const infoMeta_title = (res) => {
  return {
    type: INFO_META_TITLE,
    result: res,
  };
};
export const reset = () => {
  return {
    type: RESET,
  };
};

export const title = (res) => {
  return {
    type: TITLE,
    result: res,
  };
};

export const description = (res) => {
  return {
    type: DESCRIPTION,
    result: res,
  };
};

export const text_index = (res) => {
  return {
    type: TEXT_INDEX,
    result: res,
  };
};
export const layout = (res) => {
  return {
    type: LAYOUT,
    titleLayout: res.titleLayout,
    result: res.layout,
  };
};
export const reload_api = (res) => {
  return {
    type: RELOAD_API,
    result: res,
  };
};
export const set_layout_list = (res) => {
  return {
    type: SET_LAYOUT_LIST,
    result: res,
  };
};

export const set_layout_title = (res) => {
  return {
    type: SET_LAYOUT_TITLE,
    result: res,
  };
};

export const reorder_layout_list = (res) => {
  return {
    type: REORDER_LAYOUT_LIST,
    result: res,
  };
};
export const rename_layout_list = (res, title) => {
  return {
    type: RENAME_LAYOUT_LIST,
    result: res,
    title: title,
  };
};

export const set_layout_languages = (res) => {
  return {
    type: SET_LAYOUT_LANGUAGES,
    result: res
  }
}

export const set_anchor_navigation = (res) => {
  return {
    type: SET_ANCHOR_NAVIGATION,
    result: res
  }
}

export const enable_anchor_navigation = () => {
  return {
    type: ENABLE_ANCHOR_NAVIGATION
  }
}

export const set_sticky_anchor_navigation = () => {
  return {
    type: SET_STICKY_ANCHOR_NAVIGATION
  }
}

export const set_default_page = (page) => {
  return {
    type: SET_DEFAULT_PAGE,
    payload: page
  }
}

export const set_anchor_list = (list) => {
  return {
    type: SET_ANCHOR_LIST,
    payload: list
  }
}

export const add_anchor = (name, link) => {
  return {
    type: ADD_ANCHOR,
    payload: {name: name, link: link}
  }
}

export const rename_anchor = (index, newName, newLink) => {
  return {
    type: RENAME_ANCHOR,
    payload: {index, newName, newLink}
  }
}

export const delete_anchor = (index) => {
  return {
    type: DELETE_ANCHOR,
    payload: index
  }
}

export const delete_layout_list = (res, index) => {
  return {
    type: DELETE_LAYOUT_LIST,
    result: res,
    deletedItemIndex: index,
  };
};

export const override_element_fonts = (res) => {
  return {
    type: OVERRIDE_ELEMENT_FONTS,
    result: res,
  };
};
export const canvas_column_gap = (res) => {
  return {
    type: CANVAS_COLUMN_GAP,
    result: res,
  };
};
export const canvas_row_gap = (res) => {
  return {
    type: CANVAS_ROW_GAP,
    result: res,
  };
};

export const reset_past = () => {
  
  return {
    type: RESET_PAST,
   result:[]
  }
}